module.exports = __webpack_public_path__ + "img/Loading_r_36.764a0eaa.png";